import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IUpdateDeviceParams } from '../device-setting.interfaces';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { DeviceSettingsService } from '../device-settings.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { ConfirmDialogComponent } from 'src/app/shared-layout/Components/confirm-dialog/confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-update-device-name',
  templateUrl: './update-device-name.component.html',
  styleUrls: ['./update-device-name.component.scss'],
})
export class UpdateDeviceNameComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  formGroup!: FormGroup;
  existingName: string = '';

  get formInstance() {
    return this.formGroup?.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private deviceSettingservice: DeviceSettingsService,
    private notificationService: NotificationService,
    private helperService: HelperService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;

    this.formGroup.controls.deviceName.setValidators(
      MFValidators.compose([
        MFValidators.required,
        MFValidators.requiredSpecialCharForUnitName,
        MFValidators.whitespace,
        MFValidators.maxLength(50),
      ])
    );

    this.existingName = this.formInstance?.deviceName?.value;
  }

  /**
   * @description #closeDialog will close the modal
   * @returns void
   */
  closeDialog(): void {
    let newName = this.formGroup?.controls?.deviceName?.value;
    if (this.existingName === newName) {
      this.dialogRef?.close();
      return;
    }
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmDialogComponent,
      {
        title: this.translate.instant('TITLE'),
        headingText: this.translate.instant('HEADING_TEXT'),
        bodyText: this.translate.instant('BODY_TEXT'),
        footerText: this.translate.instant('FOOTER_TEXT'),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dialogRef?.close();
      }
    });
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.formInstance?.deviceName?.patchValue(this.existingName);
    this.stepperChange.emit((this.stepper = 1));
  }

  onUpdateName(): void {
    this.deviceSettingservice
      .updateDeviceName(
        this.formInstance?.deviceId.value,
        this.formInstance?.deviceName.value
      )
      .subscribe({
        next: (res: any) => {
          if (
            res?.updateDeviceSettings?.deviceId ===
            this.formInstance?.deviceId.value
          ) {
            this.notificationService.showSuccess(
              this.translate.instant('DEVICE_UPDATED_SUCCESSFULLY')
            );
            this.stepperChange.emit((this.stepper = 1));
          }
        },
        error: (err: Error) => {
          this.notificationService.showError(err.message);
        },
      });
  }
}
